import { render, staticRenderFns } from "./minum.vue?vue&type=template&id=458afb7d&"
import script from "./minum.vue?vue&type=script&lang=js&"
export * from "./minum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports